'use client';

import { COLORS } from '@musinsa/mds';
import styled from 'styled-components';
import { MultipleRolling } from '../rolling';
import { NoticeBanner } from './NoticeBanner';

export const RollingBanner = ({
  animationnDuration = 3000,
  onClick,
  banners,
  bgColor = 'white',
}: {
  animationnDuration?: number;
  onClick: (currentRollingIndex: number) => void;
  banners: {
    key: number;
    label: string;
    labelColor?: string;
    text: string;
    textColor?: string;
    left?: React.ReactNode;
    right?: React.ReactNode;
  }[];
  bgColor?: 'white' | 'gray';
}) => {
  let currentRollingIndex = 0;
  return (
    <Container onClick={() => onClick(currentRollingIndex)} $bgColor={bgColor}>
      <MultipleRolling
        onActiveIndexChange={(index) => {
          currentRollingIndex = index;
        }}
        animationnDuration={animationnDuration}
      >
        {banners.map(({ key, label, labelColor, text, textColor, left, right }) => (
          <NoticeBanner
            key={key}
            bgColor={bgColor}
            label={label}
            labelColor={labelColor}
            text={text}
            textColor={textColor}
            left={left}
            right={right}
            containerStyle={{ padding: 0 }}
          />
        ))}
      </MultipleRolling>
    </Container>
  );
};

const Container = styled.div<{ $bgColor: 'white' | 'gray' }>`
  height: 40px;
  padding: 8px 10px;
  overflow: hidden;
  background-color: ${({ $bgColor }) => ($bgColor === 'gray' ? COLORS.gray['100'] : COLORS.white)};
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
`;
